
import React from "react";
// import Construction from "../src/pages/construction"
import {
  BrowserRouter as Router,
} from "react-router-dom";

// import Navbar from './pages/navbar'
import Routes from "./routes";
import './App.css'

function App() {
  
  return (
    <>
        <Router>
            <div className={"body-container"}>
                {/* <Navbar /> */}
                <div className={"body-routes"} >
                    <Routes />
                </div>
            </div>
      </Router>
    </>
  );
}

export default App;